import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TraduccionesComponent } from '../../../../Alsa-MA-Angular-utils/src/app/traducciones.component';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var initMap: any;
declare var moveUserPosition: any;
declare var nombreOrigen: any;
declare var nombreDestino: any;
declare var colorLineaClicada: any;
declare var IDLineaClicada: any;

declare var stops: any;

@Component({
  selector: 'app-service-information-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['../service-information.component.css']
})

export class MapaComponent implements OnInit, OnDestroy {
  /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
  i18nL = TraduccionesComponent.arrayTraducciones;

  /*------------------------------------------------ Variables VSC -------------------------------------------------*/
  origen = ''; destino = ''; idLinea = ''; colorLinea = '#FF0000';
  firstLoad = true;


  /*----------------------------------------------- Funciones ----------------------------------------------------*/
  public poblarVariables(){
    this.origen = nombreOrigen;
    this.destino = nombreDestino;
    this.colorLinea = colorLineaClicada;
    this.idLinea = IDLineaClicada;
  }


  public setTraducciones() {
    if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
      this.i18nL = i18nVS;
    }
  }

  public throwSearch() {
    moveUserPosition();
  }

  public crearMapa() {
    console.log('Componente Maps creado OnInit');
    this.setTraducciones();
    this.poblarVariables(); 
    initMap();    
  }

  public crearMapaCorrutine() {
      if (typeof stops != "undefined") {
          this.crearMapa();   
      } else {
          setTimeout(() => this.crearMapaCorrutine(), 250);   
      }  
  }
  
  /*--------------------------------------------- Eventos ------------------------------------------------------*/
  ngOnInit() {
      this.crearMapaCorrutine();
  }
  ngOnDestroy() {
    console.log('Componente Maps destruido');
  }

  /*--------------------------------------------- Constructores ------------------------------------------------*/
  constructor(private _ngZone: NgZone, private _sanitizer: DomSanitizer) { }
}



// WEBPACK FOOTER //
// ./src/app/mapa/mapa.component.ts